import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axiosInstance from "../../helpers/axiosInstance";
import { EventSlotState } from "../../pages/eventDetails";

export type EventSlots = EventSlotState[];

interface EventSlotSliceState {
  slots: EventSlots;
  loading: boolean;
  error: string | null;
}

const initialState: EventSlotSliceState = {
  slots: [],
  loading: false,
  error: null,
};

export const fetchEventSlots = createAsyncThunk<EventSlots, number | string | null>(
  "eventSlots/fetchEventSlots",
  async (eventId, { rejectWithValue }) => {
    try {
      if (!eventId) {
        return rejectWithValue("Invalid eventId");
      }

      const response = await axiosInstance.get(`api/eventregistration/event-slots/${eventId}`);

      return (response.data?.body ?? []) as EventSlots;
    } catch {
      return rejectWithValue("Failed to fetch event slots");
    }
  }
);

const eventSlotSlice = createSlice({
  name: "eventSlots",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEventSlots.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchEventSlots.fulfilled,
        (state, action: PayloadAction<EventSlots>) => {
          state.loading = false;
          state.slots = action.payload;
        }
      )
      .addCase(fetchEventSlots.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default eventSlotSlice.reducer;
